import { createContext, useContext, type ReactNode } from 'react';
import type { CanvasDesignerMode } from './types';

export const DEFAULT_CANVAS_DESIGNER_MODE: CanvasDesignerMode = 'slide';

const CanvasModeContext = createContext<CanvasDesignerMode>(DEFAULT_CANVAS_DESIGNER_MODE);

export function CanvasModeProvider({
  mode,
  children,
}: {
  mode: CanvasDesignerMode;
  children: ReactNode;
}) {
  return (
    <CanvasModeContext.Provider value={mode}>
      {children}
    </CanvasModeContext.Provider>
  );
}

export function useCanvasMode(): CanvasDesignerMode {
  return useContext(CanvasModeContext);
}
